<template>
  <div class="field">
    <component
      v-for="(field, key) in data"
      :key="key"
      :is="field.component"
      :data="field.data"
      :functions="field.hasOwnProperty('functions') && field.functions || null"
      v-model="value[key]"/>
  </div>
</template>

<script>
// Recursive component `InputGroup` for nested keys
export default {
  name: 'InputGroup',
  props: {
    value: {
      type: Object,
      required: false
    },
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      input: this.value
    }
  },
  watch: {
    input: {
      handler: function (value) {
        this.$emit('input', this.input)
      },
      deep: true
    }
  }
}
</script>
